import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';

export class FacetGroup {

    facets: Facet[];

    constructor(
        public label: string,
        facets: Array<any>,
        group: string
    ) {
        this.facets = this.mapFacets(facets, group);
    }

    mapFacets(facets: Array<any>, group: string): Facet[] {
        return facets.map((facet) => new Facet(
            facet.urlFriendlyId,
            facet.value,
            false,
            group,
            facet.description
        ));
    }
}
